import React from 'react';
import { motion } from 'framer-motion';
export function Authority() {
  return <section className="py-24 md:py-32 bg-dark-900 relative overflow-hidden" data-id="element-11">
      {/* Subtle background blob */}
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-brand-muted/5 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-12"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-13">
        <div className="max-w-4xl mx-auto bg-dark-800/50 border border-dark-700 rounded-3xl p-8 md:p-16 backdrop-blur-sm" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-15">
            <span className="text-brand-muted tracking-widest uppercase text-sm font-medium mb-4 block text-center" data-id="element-16">
              Sobre A. Camacho
            </span>
            <div className="flex justify-center mb-6" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/6U3sZzd2tkvNbYBVXvJwRG/Final_LOGO-Jen-ChatGPT_Suggestion-removebg-preview.png" alt="Proyecto ARCA logo" className="w-10 h-10 md:w-12 md:h-12 object-contain" style={{
              filter: 'brightness(0) invert(1) opacity(0.7)'
            }} data-id="element-18" />
            </div>
            <h2 className="text-4xl md:text-6xl text-center mb-4 leading-[0.95]" data-id="element-19">
              UNA GUÍA CON EL SELLO DE
              <br data-id="element-20" />
              <span className="text-brand-muted" data-id="element-21">PROYECTO ARCA.</span>
            </h2>
            <p className="text-xl text-center text-brand-light/80 font-light mb-12" data-id="element-22">
              Herramientas reales para mentes que buscan evolucionar
            </p>

            <div className="prose prose-invert prose-lg mx-auto text-brand-muted font-light leading-relaxed" data-id="element-23">
              <p data-id="element-24">
                Fundado por Arianna Camacho, Proyecto Arca nace como un espacio
                dedicado a fusionar los principios de la neurociencia, leyes
                universales infalibles con crecimiento personal y soluciones
                prácticas para la vida moderna.
              </p>
              <p className="mt-6" data-id="element-25">
                Este eBook no es teoría, es un método creado cuidadosamente para
                ayudar a mujeres líderes y buscadores de crecimiento a
                transformar la incertidumbre emocional en su mayor ventaja
                estratégica. Aquí te enseñamos a usar el dolor a tu favor.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}